
const InformationIdType = Symbol();

export class InformationId {
    [InformationIdType]: any;
    readonly value: string;

    private constructor(informationId: string) {
        this.value = informationId;
    }

    static fromString(informationId: string): InformationId {
        return new InformationId(informationId);
    }
}
